"use client";

import confetti from "canvas-confetti";
import type { RefObject } from "react";

export const fireConffeti = async (elementRef: RefObject<HTMLDivElement | null>) => {
  if (!elementRef?.current) {
    return;
  }

  const rect = elementRef.current.getBoundingClientRect();
  const x = rect.left + rect.width / 2;
  const y = rect.top + rect.height / 2;

  await confetti({
    spread: 50,
    ticks: 230,
    particleCount: 200,
    origin: {
      x: x / window.innerWidth,
      y: y / window.innerHeight,
    },
    zIndex: 9999,
  });
};
